import { render, staticRenderFns } from "./NetaNewEventComponent.vue?vue&type=template&id=3adad01c&"
import script from "./NetaNewEventComponent.vue?vue&type=script&lang=js&"
export * from "./NetaNewEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewEventComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3adad01c')) {
      api.createRecord('3adad01c', component.options)
    } else {
      api.reload('3adad01c', component.options)
    }
    module.hot.accept("./NetaNewEventComponent.vue?vue&type=template&id=3adad01c&", function () {
      api.rerender('3adad01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-new/NetaNewEventComponent.vue"
export default component.exports